document.addEventListener('DOMContentLoaded', function () {
    console.log('Evento DOMContentLoaded attivato.');

    const appContainer = document.getElementById('whatsapp-app');

    if (!appContainer) {
        console.error('❌ Contenitore #whatsapp-app non trovato. La chat non può essere inizializzata.');
        return;
    }
    console.log('appContainer trovato:', appContainer);

    console.log('Sto per inserire lHTML della chat...');
    appContainer.innerHTML = `
        <div id="sidebar" class="w-full md:w-[35%] bg-[#f8f9fa] border-r border-gray-300 flex flex-col">
            <div class="sidebar-header flex items-center justify-between p-3 bg-[#075e54] text-white h-[60px] flex-shrink-0">
                <img src="https://placehold.co/40x40/ffffff/075e54?text=U" alt="User Avatar" class="w-10 h-10 rounded-full cursor-pointer" onerror="this.onerror=null; this.src='https://placehold.co/40x40/cccccc/333333?text=E';">
                <div class="actions flex space-x-3">
                    <span class="material-icons cursor-pointer" title="Status">donut_large</span>
                    <span class="material-icons cursor-pointer" title="Nuova chat">chat</span>
                    <span class="material-icons cursor-pointer" title="Menu">more_vert</span>
                </div>
            </div>
            <div class="search-box p-2 border-b border-gray-200 bg-[#f6f6f6] flex-shrink-0">
                <input id="search-input" type="text" placeholder="Cerca o inizia una nuova chat" class="w-full px-4 py-2 border-none rounded-lg bg-white focus:ring-2 focus:ring-[#075e54] outline-none text-sm">
            </div>
            <div id="chat-list" class="chat-list flex-1 overflow-y-auto">
                <div id="loading" class="p-4 text-center">
                    <svg class="animate-spin h-8 w-8 text-[#075e54] mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <p class="mt-2">Caricamento chat...</p>
                </div>
            </div>
        </div>
        <div id="chat-window-container" class="w-full md:w-[65%] flex flex-col bg-[#f0f2f5] hidden md:flex">
            <div class="chat-header flex items-center justify-between p-3 bg-[#ededed] border-b border-gray-300 h-[60px] flex-shrink-0">
                <div class="user-info flex items-center">
                    <span id="back-to-list-button" class="material-icons cursor-pointer mr-3 md:hidden hover:text-[#075e54]">arrow_back</span>
                    <div id="chat-header-avatar" class="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-xl text-white mr-3 flex-shrink-0">
                        <span class="material-icons">person</span>
                    </div>
                    <div class="flex flex-col">
                        <div id="chat-name" class="font-semibold text-gray-700 text-base">Seleziona una chat</div>
                        <div id="chat-status" class="text-xs text-gray-500">online</div>
                    </div>
                </div>
                <div class="actions flex space-x-3 text-gray-500">
                    <span class="material-icons cursor-pointer hover:text-[#075e54]" title="Cerca messaggi">search</span>
                    <span class="material-icons cursor-pointer hover:text-[#075e54]" title="Allega file">attach_file</span>
                    <span class="material-icons cursor-pointer hover:text-[#075e54]" title="Altre opzioni">more_vert</span>
                </div>
            </div>
            <div id="messages-container" class="messages-container flex-1 p-4 overflow-y-auto bg-[#ece5dd] space-y-3">
                <div id="empty-chat-placeholder" class="flex flex-col items-center justify-center h-full text-gray-500">
                    <span class="material-icons text-7xl mb-3 text-gray-400">chat_bubble_outline</span>
                    <p class="text-lg text-center">Seleziona una chat per iniziare a messaggiare.</p>
                    <p class="text-sm mt-1 text-gray-400">Oppure cerca tra i tuoi contatti.</p>
                </div>
            </div>
            <div class="chat-input p-3 bg-[#f0f2f5] border-t border-gray-300 flex items-center space-x-2 flex-shrink-0 h-[62px]">
                <span class="material-icons text-gray-500 cursor-pointer hover:text-[#075e54] p-1" title="Emoji">sentiment_satisfied_alt</span>
                <input id="message-input-field" type="text" placeholder="Scrivi un messaggio..." class="flex-1 px-4 py-2.5 border-none rounded-lg bg-white focus:ring-2 focus:ring-[#075e54] outline-none text-sm">
                <button id="send-message-button" class="p-2.5 rounded-full text-white bg-[#075e54] hover:bg-[#064e48] transition-colors">
                    <span class="material-icons leading-none">send</span>
                </button>
            </div>
        </div>
    `;
    console.log('HTML della chat inserito.');

function initializeChats() {
    console.log('[CHAT SCRIPT] initializeChats chiamata.');

    // ⬇️⬇️⬇️ ASSICURATI CHE QUESTO SIA L'URL CORRETTO DEL TUO FILE CSV CARICATO SU SHOPIFY ⬇️⬇️⬇️
    const csvUrl = 'https://cdn.shopify.com/s/files/1/0558/0514/9316/files/Messaggi_clienti.csv';
    // ⬆️⬆️⬆️ Se hai ricaricato un CSV corretto, USA IL NUOVO URL QUI ⬆️⬆️⬆️

    console.log('[CHAT SCRIPT] URL da testare con fetch:', csvUrl);

    const loadingEl = document.getElementById('loading');
    const chatListEl = document.getElementById('chat-list-items'); // Usiamo il container corretto
    const messagesDisplayArea = document.getElementById('messages-display-area'); // Per messaggi di errore/successo

    console.log('[CHAT SCRIPT] Avvio della richiesta fetch...');
    fetch(csvUrl, { cache: 'reload' }) // Aggiunto {cache: 'reload'} come nell'esempio funzionante
        .then(response => {
            console.log('[CHAT SCRIPT] Risposta fetch ricevuta. Status:', response.status, response.statusText);
            if (!response.ok) {
                console.error('[CHAT SCRIPT] Errore nella risposta HTTP:', response);
                if (loadingEl) loadingEl.innerHTML = `<p style="color:red;">Errore ${response.status} nel caricare il CSV.</p>`;
                throw new Error('Network response was not ok: ' + response.statusText);
            }
            return response.text();
        })
        .then(csvText => {
            console.log('[CHAT SCRIPT] Contenuto CSV ottenuto. Lunghezza:', csvText.length);
            console.log('[CHAT SCRIPT] Prime 200 chars del CSV (originale):', csvText.substring(0, 200));

            let processedCsvText = csvText;
            // Tentativo di pulizia se il CSV inizia con "l," o "1," (adattare se necessario)
            // Questo cerca la prima occorrenza di "DATA,PUNTEGGIO,MESSAGGIO,NOME" e prende da lì in poi.
            // È un modo un po' grezzo, correggere il file CSV è meglio.
            const headerSignature = "DATA,PUNTEGGIO,MESSAGGIO,NOME"; // Assicurati che corrisponda esattamente alle tue intestazioni
            const headerIndex = processedCsvText.indexOf(headerSignature);

            if (headerIndex > 0 && headerIndex < 5) { // Se l'header non è all'inizio ma c'è qualcosa prima (entro i primi 5 caratteri)
                console.warn('[CHAT SCRIPT] Trovato testo prima delle intestazioni attese. Tento la pulizia.');
                processedCsvText = processedCsvText.substring(headerIndex);
                console.log('[CHAT SCRIPT] Prime 200 chars del CSV (dopo tentativo di pulizia):', processedCsvText.substring(0, 200));
            } else if (headerIndex === -1) {
                 console.warn('[CHAT SCRIPT] Intestazioni CSV ("DATA,PUNTEGGIO,MESSAGGIO,NOME") non trovate! Il parsing potrebbe fallire o dare risultati imprevisti.');
            }


            if (typeof Papa !== 'undefined') {
                console.log('[CHAT SCRIPT] Tento il parsing del testo CSV con PapaParse...');
                try {
                    Papa.parse(processedCsvText, { // Usa processedCsvText
                        header: true,
                        skipEmptyLines: true,
                        complete: function(results) {
                            console.log('[CHAT SCRIPT] Parsing del testo CSV COMPLETATO con PapaParse:', results);
                            
                            if (results.errors && results.errors.length > 0) {
                                console.error('[CHAT SCRIPT] Errori durante il parsing PapaParse:', results.errors);
                                if (loadingEl) loadingEl.innerHTML = '<p style="color:red;">Errore nel formato del CSV.</p>';
                                results.errors.forEach(err => console.error("Dettaglio errore PapaParse:", err));
                                return;
                            }

                            if (results.data && results.data.length > 0) {
                                console.log('[CHAT SCRIPT] Dati CSV parsati validi:', results.data.length, "righe.");
                                if (loadingEl) loadingEl.style.display = 'none'; // Nascondi caricamento
                                // Ora dovresti chiamare la funzione per processare e visualizzare le chat
                                // processAndDisplayConversations(results.data); // (Questa funzione va definita)
                                if (chatListEl) chatListEl.innerHTML = `<p style="color:green; text-align:center;">Dati CSV Caricati e Parsati! (${results.data.length} righe).<br>Prossimo passo: visualizzazione.</p>`;

                            } else {
                                console.warn('[CHAT SCRIPT] Nessun dato valido o dati vuoti dopo il parsing PapaParse. Controlla il CSV e le intestazioni.');
                                if (loadingEl) loadingEl.innerHTML = '<p style="color:orange;">CSV parsato, ma nessun dato trovato o formato non corretto.</p>';
                            }
                        },
                        error: function(error) { // PapaParse chiama questo per errori di parsing ASINCRONI
                            console.error('[CHAT SCRIPT] Errore ASINCRONO durante il parsing PapaParse:', error);
                            if (loadingEl) loadingEl.innerHTML = '<p style="color:red;">Errore durante il parsing del CSV.</p>';
                        }
                    });
                    console.log('[CHAT SCRIPT] Chiamata a Papa.parse(processedCsvText) effettuata (operazione asincrona).');
                } catch (e) {
                    console.error('[CHAT SCRIPT] Errore SINCRONO chiamando Papa.parse(processedCsvText):', e);
                    if (loadingEl) loadingEl.innerHTML = '<p style="color:red;">Errore critico parsing CSV.</p>';
                }
            } else {
                console.error('[CHAT SCRIPT] Papa non è definito! Impossibile parsare il CSV.');
                if (loadingEl) loadingEl.innerHTML = '<p style="color:red;">Libreria PapaParse mancante.</p>';
            }
        })
        .catch(error => {
            console.error('[CHAT SCRIPT] Errore generale durante il processo di fetch:', error);
            if (loadingEl) loadingEl.innerHTML = `<p style="color:red;">Errore fetch: ${error.message}</p>`;
        });

    console.log('[CHAT SCRIPT] Chiamata a fetch effettuata (operazione asincrona).');

    // Qui dovrai rimettere il resto della logica per popolare l'UI
    // (renderChatList, openChat, processCsvData che ora prende results.data, etc.)
    // Per ora, ci concentriamo sul far arrivare i dati qui.
}

    // Chiama la funzione per avviare la logica
    initializeChats();

}); // --- Fine del listener DOMContentLoaded ---